import React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cn } from "lib/utils";

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef(({ className, ...props }, ref) => (
    <TabsPrimitive.List
        ref={ref}
        className={cn(
            "tw-flex tw-items-center tw-gap-1 tw-bg-neutral-100/80 tw-p-1 tw-rounded-lg",
            className,
        )}
        {...props}
    />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef(({ className, hasError, ...props }, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
            "tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-py-2",
            "tw-rounded-md tw-text-sm tw-font-medium tw-cursor-pointer",
            "tw-text-neutral-400 tw-bg-transparent tw-border-0",
            "tw-transition-all tw-duration-200 tw-relative",
            "hover:tw-text-brand-dark hover:tw-bg-white/60",
            "data-[state=active]:tw-bg-white data-[state=active]:tw-text-brand-dark data-[state=active]:tw-shadow-card",
            hasError && "tw-text-red-500 data-[state=active]:tw-text-red-600",
            "focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-brand-pink/30",
            className,
        )}
        {...props}
    />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef(({ className, forceMount, ...props }, ref) => (
    <TabsPrimitive.Content
        ref={ref}
        forceMount={forceMount}
        className={cn(
            "tw-mt-5 focus-visible:tw-outline-none",
            forceMount && "data-[state=inactive]:tw-hidden",
            className,
        )}
        {...props}
    />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
